module.exports = __webpack_public_path__ + "img/icon-face.bb000468.svg";